import type { IconNode } from '../types';

/**
 * @name lemon
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuNiAyLjRjLS41LjItMS4zLjYtMS44LjZIMTJhOSA5IDAgMCAwLTkgOXYzLjhjMCAuNi0uNCAxLjMtLjYgMS44YTIuOTUgMi45NSAwIDAgMCA0IDRjLjUtLjIgMS4zLS42IDEuOC0uNkgxMmE5IDkgMCAwIDAgOS05VjguMmMwLS42LjQtMS4zLjYtMS44YTIuOTUgMi45NSAwIDAgMC00LTQiIC8+CiAgPHBhdGggZD0iTTcgMTJjMC0yLjggMi4yLTUgNS01IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/lemon
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const lemon: IconNode = [
  [
    'path',
    {
      d: 'M17.6 2.4c-.5.2-1.3.6-1.8.6H12a9 9 0 0 0-9 9v3.8c0 .6-.4 1.3-.6 1.8a2.95 2.95 0 0 0 4 4c.5-.2 1.3-.6 1.8-.6H12a9 9 0 0 0 9-9V8.2c0-.6.4-1.3.6-1.8a2.95 2.95 0 0 0-4-4',
      key: '11kyrn',
    },
  ],
  ['path', { d: 'M7 12c0-2.8 2.2-5 5-5', key: 'xr93qa' }],
];

export default lemon;
